import script from "./Image.vue?vue&type=script&setup=true&lang=ts"
export * from "./Image.vue?vue&type=script&setup=true&lang=ts"

import "./Image.vue?vue&type=style&index=0&id=10ab4451&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10ab4451"]])

export default __exports__